import Vue from 'vue'
import Router from 'vue-router'
import authService from '@/services/authService'
import store from '@/stores'
import GTMService from '@/services/GTMService'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!authService.isLoggedIn()) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = async (to, from, next) => {
  if (authService.isLoggedIn()) {
    // Ensure we have a user on every route
    if (store.state.GET_USER_RESPONSE === null) {
      await store.dispatch('getUser')
      await store.dispatch('getHCP')
    }
    GTMService.pushData(store.state.GET_USER_RESPONSE)
    next()
    return
  }
  next('/login')
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'home',
      component: () => import(/* webpackChunkName: "page" */ './layouts/Page.vue'),
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
          beforeEnter: ifAuthenticated
        },
        {
          path: '/patients/:patientId?',
          name: 'patients',
          props: true,
          component: () => import(/* webpackChunkName: "patients" */ './views/Patients.vue'),
          beforeEnter: ifAuthenticated
        },
        {
          path: '/referrals',
          name: 'referrals',
          props: true,
          component: () => import(/* webpackChunkName: "referrals" */ './views/Referrals.vue'),
          beforeEnter: ifAuthenticated
        },
        {
          path: '/resources',
          name: 'resources',
          component: () => import(/* webpackChunkName: "resources" */ './views/Resources.vue'),
          beforeEnter: ifAuthenticated
        },
        {
          path: '/complementary',
          name: 'complementary',
          component: () => import(/* webpackChunkName: "complementary-kits" */ './views/ComplementaryKits'),
          beforeEnter: ifAuthenticated
        },
        {
          path: '/account',
          name: 'account',
          component: () => import(/* webpackChunkName: "account" */ './views/Account'),
          beforeEnter: ifAuthenticated
        },
        {
          path: '/result',
          name: 'result',
          props: true,
          component: () => import(/* webpackChunkName: "result" */ './views/Result'),
          beforeEnter: ifAuthenticated
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login'),
      beforeEnter: ifNotAuthenticated,
      props: true
    },
    {
      path: '/reset-password',
      name: 'Reset password',
      component: () => import(/* webpackChunkName: "reset-password" */ './views/ResetPassword'),
      beforeEnter: ifNotAuthenticated
    }
  ]
})
